import {
  ApartmentOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  CalendarOutlined,
  ClearOutlined,
  ClusterOutlined,
  CommentOutlined,
  CopyOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  ExperimentOutlined,
  FileProtectOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  GiftOutlined,
  HddOutlined,
  HomeOutlined,
  IdcardOutlined,
  InfoCircleOutlined,
  MedicineBoxOutlined,
  MessageOutlined,
  ProfileOutlined,
  RobotOutlined,
  SettingOutlined,
  ShopOutlined,
  SolutionOutlined,
  TableOutlined,
  TagsOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  WalletOutlined
} from "@ant-design/icons";
import { PROGRAM_MODULES } from "../../core/module-license";

export const HUBS = {
  numbers: {
    key: "numbers",
    path: "/hub/numbers",
    tabTitle: "Управление номерами",
    eyebrow: "Номерной фонд",
    title: "Управление номерами",
    lead: "Путевки, фонд, категории, прайс и шахматка — все формы раздела в одном месте.",
    module: PROGRAM_MODULES.NUMBER,
    tiles: [
      { key: "exp", title: "Путевки", hint: "Журнал путёвок, заезды и расчёт", path: "/doc/exp", icon: IdcardOutlined, law: 5, featured: true },
      { key: "bron", title: "Шахматка", hint: "Загрузка фонда по дням и бронь", path: "/bron", icon: CalendarOutlined, law: 11, featured: true },
      { key: "number", title: "Номера", hint: "Фонд, группы и карточки номеров", path: "/spr/number", icon: HomeOutlined, law: 4 },
      { key: "number-cat", title: "Категории номеров", hint: "Места, подселение и питание", path: "/spr/number-cat", icon: AppstoreOutlined, law: 4 },
      { key: "number-price", title: "Прайс-листы", hint: "Цены на проживание и услуги", path: "/number/price", icon: TagsOutlined, law: 4 },
      { key: "docs", title: "Документы", hint: "Печатные формы номерного фонда", icon: FileTextOutlined, unimplemented: true },
      { key: "sert", title: "Сертификаты", hint: "Подарочные и служебные сертификаты", icon: GiftOutlined, unimplemented: true },
      { key: "card-discount", title: "Дисконтные карты", hint: "Скидки и карты лояльности", icon: CreditCardOutlined, unimplemented: true },
      { key: "rent", title: "Аренда объектов", hint: "Сдача помещений и инвентаря", icon: ShopOutlined, unimplemented: true },
      { key: "tarif", title: "Шаблоны путевок", hint: "Типовые пакеты проживания", icon: CopyOutlined, unimplemented: true },
      { key: "housemaid", title: "Сервис номеров", hint: "Уборка и обслуживание фонда", icon: ClearOutlined, unimplemented: true }
    ]
  },
  dialogs: {
    key: "dialogs",
    path: "/hub/dialogs",
    tabTitle: "Диалоги",
    eyebrow: "Коммуникации",
    title: "Диалоги",
    lead: "Переписка с гостями, каналы и агенты в одном разделе.",
    tiles: [
      { key: "dialogs", title: "Диалоги", hint: "Входящие обращения и переписка", path: "/dialogs", icon: MessageOutlined, law: 110, featured: true },
      { key: "channels", title: "Каналы", hint: "Мессенджеры и точки входа", path: "/dialogs/channels", icon: CommentOutlined, law: 40 },
      { key: "agents", title: "Агенты", hint: "Подключения внешних агентов", path: "/dialogs/agents", icon: RobotOutlined, law: 40 }
    ]
  },
  warehouse: {
    key: "warehouse",
    path: "/hub/warehouse",
    tabTitle: "Склад",
    eyebrow: "Товары",
    title: "Склад",
    lead: "Накладные, остатки и движения товаров.",
    module: PROGRAM_MODULES.WAREHOUSE,
    tiles: [
      { key: "documents", title: "Накладные", hint: "Приход, расход и перемещение", path: "/warehouse/documents", icon: FileTextOutlined, law: 90, featured: true },
      { key: "register", title: "Остатки", hint: "Остатки по складам и номенклатуре", path: "/warehouse/register", icon: HddOutlined, featured: true },
      { key: "product-card", title: "Карточка товара", hint: "Движения и остатки товара за период", path: "/warehouse/product-card", icon: ProfileOutlined },
      { key: "movements", title: "Движения товаров", hint: "История приходов и списаний", path: "/warehouse/movements", icon: UnorderedListOutlined }
    ]
  },
  nutrition: {
    key: "nutrition",
    path: "/hub/nutrition",
    tabTitle: "Питание",
    eyebrow: "Столовая",
    title: "Питание",
    lead: "Меню, карта питания, регистрация и залы.",
    module: PROGRAM_MODULES.NUTRITION,
    tiles: [
      { key: "templates", title: "Шаблоны меню", hint: "Рационы и состав блюд", path: "/nutrition/templates", icon: CopyOutlined, featured: true },
      { key: "map", title: "Карта питания", hint: "План питания на период", path: "/nutrition/map", icon: CalendarOutlined, featured: true },
      { key: "registration", title: "Регистрация питания", hint: "Отметка по карте гостя", path: "/nutrition/register", icon: IdcardOutlined, law: 83 },
      { key: "halls", title: "Залы и столы", hint: "Схема залов столовой", path: "/nutrition/tables", icon: TableOutlined, law: 84 },
      { key: "cost", title: "Стоимость питания", hint: "Расчёт стоимости рационов", path: "/nutrition/cost", icon: WalletOutlined }
    ]
  },
  health: {
    key: "health",
    path: "/hub/health",
    tabTitle: "Лечение",
    eyebrow: "Лечебная часть",
    title: "Лечение",
    lead: "Клиенты и кабинеты процедур.",
    module: PROGRAM_MODULES.HEALTH,
    tiles: [
      { key: "clients", title: "Клиенты", hint: "Карты, назначения и приёмы", path: "/health/clients", icon: MedicineBoxOutlined, featured: true },
      { key: "zal", title: "Кабинеты", hint: "Расписание кабинетов и процедур", path: "/spr/zal", icon: ExperimentOutlined, featured: true }
    ]
  },
  service: {
    key: "service",
    path: "/hub/service",
    tabTitle: "Сервис",
    eyebrow: "Администрирование",
    title: "Сервис",
    lead: "Проверка базы, отчёты, монитор и настройки системы.",
    tiles: [
      { key: "check-db", title: "Проверка базы", hint: "Контроль целостности данных", path: "/service/check-db", icon: DatabaseOutlined, featured: true },
      { key: "reports", title: "Отчёты", hint: "Конструктор и печать отчётов", path: "/service/reports", icon: BarChartOutlined, law: 81, featured: true },
      { key: "monitor", title: "Монитор", hint: "Активность пользователей", path: "/service/monitor", icon: DesktopOutlined, law: 67 },
      { key: "backup", title: "Резервная копия", hint: "Сохранение и восстановление базы", icon: HddOutlined, unimplemented: true },
      { key: "settings", title: "Настройки", hint: "Параметры рабочего места", path: "/service/settings", icon: SettingOutlined, law: 40 }
    ]
  },
  sprs: {
    key: "sprs",
    path: "/hub/sprs",
    tabTitle: "Справочники",
    eyebrow: "НСИ",
    title: "Справочники",
    lead: "Сотрудники, услуги, контрагенты и прочие классификаторы.",
    tiles: [
      { key: "sotr", title: "Сотрудники", hint: "Персонал и права доступа", path: "/spr/sotr", icon: TeamOutlined, law: 0, featured: true },
      { key: "tov", title: "Товары, услуги", hint: "Номенклатура услуг и товаров", path: "/spr/tov", icon: UnorderedListOutlined, featured: true },
      { key: "kompl", title: "Комплекты", hint: "Состав комплектов товаров", path: "/spr/kompl", icon: AppstoreOutlined },
      { key: "pred", title: "Контрагенты", hint: "Организации и гости", path: "/spr/pred", icon: SolutionOutlined, law: 12 },
      { key: "template-nazn", title: "Шаблоны назначений", hint: "Типовые курсы процедур", path: "/spr/template-nazn", icon: CopyOutlined },
      { key: "text", title: "Шаблоны", hint: "Текстовые шаблоны документов", path: "/spr/text", icon: FileProtectOutlined, law: 1 },
      { key: "holidays", title: "Праздники", hint: "Календарь нерабочих дней", path: "/spr/holidays", icon: CalendarOutlined, law: 39 },
      { key: "kassa", title: "Кассы", hint: "Кассы и терминалы оплаты", path: "/spr/kassa", icon: WalletOutlined, law: 48 },
      { key: "servis", title: "Виды диагнозов и записей в дневник", hint: "Справочник лечебных записей", path: "/spr/servis", icon: FileSearchOutlined, law: 98 },
      { key: "status", title: "Статусы", hint: "Статусы номерного фонда", path: "/spr/status", icon: ClusterOutlined, law: 43, module: PROGRAM_MODULES.NUMBER },
      { key: "cards", title: "Карты", hint: "Карты гостей: регистрация и выдача", path: "/spr/cards", icon: CreditCardOutlined, law: 46 },
      { key: "card-vids", title: "Типы карт", hint: "Виды карт гостей и их цвета", path: "/spr/card-vids", icon: TagsOutlined, law: 46 },
      { key: "number-spr", title: "Дополнительные", hint: "Доп. справочники номеров", path: "/spr/number-spr", icon: ApartmentOutlined, law: 4, module: PROGRAM_MODULES.NUMBER }
    ]
  },
  help: {
    key: "help",
    path: "/hub/help",
    tabTitle: "Помощь",
    eyebrow: "Справка",
    title: "Помощь",
    lead: "Сведения о программе и база знаний.",
    tiles: [
      { key: "about", title: "О программе", hint: "Версия, лицензия и контакты", path: "/help/about", icon: InfoCircleOutlined, featured: true },
      {
        key: "docs",
        title: "База знаний",
        hint: "Руководства по разделам программы",
        path: "https://help.proffitel.ru/",
        icon: FileSearchOutlined,
        featured: true,
        external: true
      }
    ]
  }
};

export const HUB_BY_KEY = HUBS;

export const HUB_PATHS = Object.fromEntries(
  Object.values(HUBS).map((hub) => [hub.key, hub.path])
);
